import { can, cannot, isLicensedTo, hasSubscription } from '@/general'

export default {
  methods: {
    can,
    cannot,
    isLicensedTo,
    hasSubscription,
  },
}
